import $ from "./jquery-global";

export default function domReady(callback) {
    $(function () {
        callback();
    });
}
